import { createAction, handleActions } from "redux-actions"
import produce from "immer"

const INIT_BANK_ACCOUNT_STATE = "bankAccountStateInfoAction/initBankAccountState"
const UPDATE_BANK_ACCOUNT_STATE = "bankAccountStateInfoAction/updateBankAccountState"

export const initBankAccountState = createAction(INIT_BANK_ACCOUNT_STATE)
export const updateBankAccountState = createAction(UPDATE_BANK_ACCOUNT_STATE)

const initialState = {
  bank_code: "",
  account_number: "",
  account_holder_name: "",
}

export default handleActions(
  {
    [INIT_BANK_ACCOUNT_STATE]: (state, _) => {
      return produce(state, (draft) => {
        draft.bank_code = ""
        draft.account_number = ""
        draft.account_holder_name = ""
      })
    },
    [UPDATE_BANK_ACCOUNT_STATE]: (state, action) => {
      return produce(state, (draft) => {
        draft.bank_code = action.payload.bank_code
        draft.account_number = action.payload.account_number
        draft.account_holder_name = action.payload.account_holder_name
      })
    },
  },
  initialState
)
